// Import the necessary modules...
import "./src/flex-content/accordion-bloc.js";
import "./src/menu.js";
import "./src/flex-content/slider.js";

window.addEventListener('DOMContentLoaded', function() {

    //wait until images, links, fonts, stylesheets, and js is loaded
    window.addEventListener("load", function() {

        // Initialize...

   });

});
